import React from 'react'

import { Button, Icon } from 'components/UI'

import generateWeeklyDate from '../../../../../../helpers/generateWeeklyDate'

const CalendarTitle = ({ onNavigate, date, renderAfter }) => {
  return (
    <div className="flex flex-col items-center mt-2 mb-4">
      <div className="flex justify-center items-center">
        <Button className="bg-transparent" onClick={() => onNavigate('PREV')}>
          <Icon name="arrow-right" color="#F79009" className="w-[24px] h-[24px] rotate-180" />
        </Button>

        <b className="text-[24px] text-bold inline-block">{generateWeeklyDate(date)}</b>

        <Button className="bg-transparent" onClick={() => onNavigate('NEXT')}>
          <Icon name="arrow-right" color="#F79009" className="w-[24px] h-[24px]" />
        </Button>
      </div>

      {renderAfter && renderAfter()}
    </div>
  )
}

export default React.memo(CalendarTitle)
